import EnableLocationSFC from "./EnableLocation.vue";
export const EnableLocation = EnableLocationSFC;
